import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function NewsletterCTA() {
  const { t } = useTranslation('home');
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setStatus('error');
      return;
    }
    setStatus('success');
    setEmail('');
  };

  return (
    <section className="w-full bg-ink-50 py-12 md:py-16 lg:py-20">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="max-w-2xl mx-auto text-center">
          <span className="text-xs font-medium text-warm-500 uppercase tracking-[0.15em] mb-4 block">
            {t('newsletter.label') || 'Stay Informed'}
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-ink-700 mb-4">
            {t('newsletter.title') || 'Industry insights delivered monthly'}
          </h2>
          <p className="text-sm md:text-base text-ink-400 mb-8 max-w-lg mx-auto">
            {t('newsletter.subtitle') || 'Receive updates on packaging trends, supplier developments, and market intelligence relevant to cosmetic procurement professionals.'}
          </p>

          <form
            onSubmit={handleSubmit}
            className="flex flex-col sm:flex-row gap-3 max-w-lg mx-auto"
          >
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                if (status !== 'idle') setStatus('idle');
              }}
              placeholder={t('newsletter.placeholder') || 'Enter your business email'}
              className="flex-1 px-5 py-3.5 bg-white border border-ink-200 text-ink-700 placeholder:text-ink-300 focus:outline-none focus:border-warm-500 focus:ring-1 focus:ring-warm-500/20 text-sm"
            />
            <button
              type="submit"
              className="px-8 py-3.5 bg-ink-700 text-white text-sm font-medium whitespace-nowrap hover:bg-ink-800 transition-colors"
            >
              {t('newsletter.button') || 'Subscribe'}
            </button>
          </form>

          {status === 'success' && (
            <p className="mt-4 text-sm text-emerald-600 font-medium">
              {t('newsletter.success') || 'Thank you for subscribing.'}
            </p>
          )}
          {status === 'error' && (
            <p className="mt-4 text-sm text-red-500 font-medium">
              {t('newsletter.error') || 'Please enter a valid email address.'}
            </p>
          )}
        </div>
      </div>
    </section>
  );
}